/** Everything that is not a preview: other types, failed renders, and images
 * or PDFs over 100 MB, which the server never previews. Clicking downloads. */

import { Download } from 'lucide-react';

import type { AttachmentOut } from '../../services/api';
import { extensionOf, formatFileSize } from '../../utils/attachments';
import { FileTypeIcon } from './FileTypeIcon';

interface AttachmentChipProps {
  attachment: AttachmentOut;
  noPreview?: boolean;
  onDownload: (id: string) => void;
}

export function AttachmentChip({
  attachment,
  noPreview = false,
  onDownload,
}: AttachmentChipProps) {
  return (
    <button
      type='button'
      aria-label={`Download ${attachment.file_name}`}
      className='flex w-full max-w-full items-center gap-2 rounded-md border px-2 py-1.5 text-left'
      onClick={() => onDownload(attachment.id)}
    >
      <FileTypeIcon fileName={attachment.file_name} />
      <span className='min-w-0 flex-1'>
        <span className='block truncate text-sm'>{attachment.file_name}</span>
        <span className='block text-xs text-muted-foreground'>
          {`${extensionOf(attachment.file_name).toUpperCase()} · ${formatFileSize(attachment.size_bytes)}`}
          {noPreview ? ' · No preview' : ''}
        </span>
      </span>
      <Download className='h-4 w-4' aria-hidden />
    </button>
  );
}
